export default __webpack_public_path__ + "static/media/wakanda6.01101a7a.jpg";